import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from 'react-select';
import axios from "axios";
import ReactPaginate from 'react-paginate';

function MyTicketList() {
  const [tickets, setTickets] = useState([]);
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [keywordticket, setKeywordTicket] = useState("");
  const [queryticket, setQueryTicket] = useState("");
  const [keywordproduct, setKeywordProduct] = useState("");
  const [queryproduct, setQueryProduct] = useState("");
  const [msg, setMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectproduct, setSelectProduct] = useState(null);
  const [optionprod, setOptionProd] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  const handleProductChange = (selectedOption) => {
    if (!selectedOption) {
      setQueryProduct("");
      setSelectProduct(null);
      setKeywordProduct("");
      //console.error("Event or event target is null/undefined");
      return; // Exit the function gracefully
    }
    const newValue = selectedOption;
    setQueryProduct(newValue.value);
    setSelectProduct(newValue);
    console.log('Option selected:', newValue);
  };

  useEffect(() => {
   
    const fetchOptionProd = async () => {
      setIsLoading(true);
      try {
        // Replace with your actual Node.js API endpoint
        const resultprod = await axios.get(`${API_BASE_URL}/product`, {
          headers: {
            'X-API-Key': API_KEY
          },
        }); 
        const dataprod = resultprod.data;

        // Map the API data to the format react-select expects: { value: '', label: '' }
        const formattedOptionProd = dataprod.map(item => ({
          value: item.id,
          label: item.name+" - "+item.manufacturer,
        }));

        setOptionProd(formattedOptionProd);
        setError(null);
      } catch (err) {
        setError('Failed to load options');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchOptionProd();
    getTickets();
  }, [page, keywordticket, keywordproduct]);

  const getTickets = async () => {
    const response = await axios.get(
      `${API_BASE_URL}/tickets?search_ticket=${keywordticket}&search_product=${keywordproduct}&page=${page}&limit=${limit}`, {
        headers: {
          'X-API-Key': API_KEY
        },
      }
    );
    setTickets(response.data.result);
    setPage(response.data.page);
    setPages(response.data.totalPage);
    setRows(response.data.totalRows);
  };

  const changePage = ({ selected }) => {
    setPage(selected);
    if (selected === 9) {
      setMsg(
        "Jika tidak menemukan data yang Anda cari, silahkan cari data dengan kata kunci spesifik!"
      );
    } else {
      setMsg("");
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeywordTicket(queryticket);
    setKeywordProduct(queryproduct);
  };

  const deleteTicket = async (ticketId) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      await axios.delete(`${API_BASE_URL}/mytickets/${ticketId}`);
      getTickets();
    } else {
      return
    }     
  };

  return (
    <div className="container mt-2">
        <h1 className="title is-size-5">My Tickets</h1>
            <div className="mb-2">
                <Link to="/mytickets/add" className="button is-small is-primary">
                Add New Ticket
                </Link>
            </div>
            <div className="columns">
            <div className="column is-9">
                <form onSubmit={searchData}>
                    <div className="columns">
                        <div className="column is-4">
                            <div className="control">
                                <input
                                type="text"
                                className="input"
                                value={queryticket}
                                onChange={(e) => setQueryTicket(e.target.value)}
                                placeholder="Filter by ticket id..." />
                            </div>
                        </div>
                        <div className="column is-6">                        
                            <div className="control is-expanded">
                            <Select
                                    value={selectproduct}
                                    onChange={handleProductChange}
                                    options={optionprod}
                                    isLoading={isLoading}
                                    isClearable={true} 
                                    placeholder="Filter by product..."
                                />
                            </div>
                        </div>
                        
                        <div className="column is-1">
                            <div className="control">
                                <button type="submit" className="button is-info">
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div className="table-container">
          <table className="table is-narrow is-striped is-hoverable is-fullwidth is-size-7">
            <thead>
                <tr>
                <th>No</th>
                <th>TicketID</th>
                <th>Product_Name</th>
                <th>Problem_Description</th>
                <th>Serial_Number</th>
                <th>Customer</th>
                <th>Status_Ticket</th>
                <th>Time_Open</th>
                <th>Time_Closed</th>
                <th>Notes_Admin</th>
                <th className="has-text-centered">Actions</th>
                </tr>
            </thead>
            <tbody>
                {tickets.map((ticket, index) => (
                <tr key={ticket.uuid}>
                    <td>{index + 1}</td>
                    <td className="has-text-centered">{ticket.ticket_id}</td>                
                    <td>{ticket.product.name.substring(0, 80)+"..."}</td>
                    <td>{ticket.description.substring(0, 100)+"..."}</td>
                    <td>{ticket.product.serialnumber}</td>
                    <td>{ticket.client.name}</td>
                    <td className="has-text-centered has-text-weight-bold">
                    {(ticket.status==="OPEN") ? <span className="tag is-success">{ticket.status}</span>
                      : (ticket.status==="REPAIRED") ? <span className="tag is-warning">{ticket.status}</span>
                      : <span className="tag is-danger">{ticket.status}</span> }                    
                    </td>
                    <td className="has-text-centered">
                        {new Date(ticket.time_open).toLocaleDateString('id', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: false,
                        })}                    
                    </td>
                    <td className="has-text-centered">
                        {ticket.time_close ? (
                            new Date(ticket.time_close).toLocaleDateString('id', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: false,
                            })
                        ) : (
                            <p>-</p>
                        )}
            
                    </td>
                    <td>{ticket.notes}</td>
                    <td className="has-text-centered">
                    <div className="is-inline-flex">
                        {ticket.status==='OPEN' || ticket.status==='CLOSED' ? (
                        <button
                        onClick={() => deleteTicket(ticket.uuid)}
                        className="button is-small is-danger"
                        >
                        Delete
                        </button>
                        ) : ticket.status==="REPAIRED" ? (
                            <Link
                            to={`/mytickets/edit/${ticket.uuid}`}
                            className="button is-small is-primary mr-1"
                            >
                            Check
                            </Link>
                        ) : (
                            <p></p>
                        )}
                    </div>
                    </td>
                </tr>
                ))}
            </tbody>
        </table>
        </div>
        <p className="is-size-7">
        Total Record: {rows} Page: {rows ? page + 1 : 0} of {pages}
        </p>
        <p className="has-text-centered has-text-danger">{msg}</p>
        <nav
        className="pagination is-centered is-size-7"
        key={rows}
        role="navigation"
        aria-label="pagination"
        >
        <ReactPaginate
            breakLabel="..."
            previousLabel={"< Prev"}
            nextLabel={"Next >"}
            pageCount={Math.min(10, pages)}
            onPageChange={changePage}
            containerClassName={"pagination-list"}
            pageLinkClassName={"pagination-link"}
            previousLinkClassName={"pagination-previous"}
            nextLinkClassName={"pagination-next"}
            activeLinkClassName={"pagination-link is-current"}
            disabledLinkClassName={"pagination-link is-disabled"} />
        </nav>
    </div>
  );
}

export default MyTicketList;
